<mat-card class="gate-to-gate-card card--bordered">
  <mat-card-header class="card-header--icon card-header--divided ">
  <app-avatar
    matCardAvatar
    [round]="true"
    bgColor="var(--color-accent-lighter)"
    fgColor="var(--color-accent)"
    iconType="svg"
    [icon]="'status-timeline'"
    [radius]="20"
    [size]="32"
    [iconSize]="'xs'"
  ></app-avatar>
  <mat-card-title class="py-0 px-2">{{'shipments.DeliveryTimeline' | translate}}</mat-card-title>
</mat-card-header>
  <mat-card-content class="pb-6">
    <app-timeline class="gate-timeline" [class.gate-timeline--delivered]="deliveredTimeline" [list]="mainTimelineItems" [itemContentTemplate]="destinationHistory"></app-timeline>
    <ng-template #destinationHistory let-item>
      <app-gate-to-gate-timeline
        *ngIf="item.group"
        [history]="item.group.history"
        [isLast]="item.groupIsLast"
      ></app-gate-to-gate-timeline>
    </ng-template>
  </mat-card-content>
</mat-card>
